
import { useLanguageContext } from '../../contexts/LanguageContext';
import Dialog, { IDialogProps } from '../Dialog';
import { ActionButton } from '../Button';
import { Grid } from '@mui/material';
import TextField from '../TextField';
import { useAuthContext } from '../../contexts/AuthContext';
import { useEffect, useCallback, useMemo } from 'react';
import FormHelper from '../../helpers/FormHelper';
import UserService from '../../services/UserService';
import ValidationHelper from '../../helpers/ValidationHelper';
import useState from '../../hooks/useState';


interface IStateValues {
    currentPassword: string;
    newPassword: string;
    repeatNewPassword: string;
}

const ChangePasswordDialog: React.FunctionComponent<Pick<IDialogProps, 'title' | 'open' | 'handleClose'>> = ({ title, open, handleClose }) => {
    const { translate } = useLanguageContext();
    const { user, handleChangeUser } = useAuthContext();

    const state = useState<IStateValues>({
        currentPassword: '',
        newPassword: '',
        repeatNewPassword: ''
    });


    useEffect(() => {
        if (open) {
            state.reset();
        }
        // eslint-disable-next-line
    }, [open]);


    const dialogActions = useMemo(() => {
        const elements = [] as JSX.Element[];

        if (!user?.forcePasswordChange) {
            elements.push(<ActionButton action='cancel' onClick={handleClose} />);
        }

        return [
            ...elements,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate, user?.forcePasswordChange]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        UserService.ChangePassword(formData).then(() => {
            if (user) {
                handleChangeUser({ ...user, forcePasswordChange: false });
                handleClose();
            }
        });
        // eslint-disable-next-line
    }, [user]);


    return (
        <Dialog 
            open={!!user?.forcePasswordChange || open}
            handleClose={handleClose}
            title={title}
            fullWidth={true}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className={!user?.forcePasswordChange ? 'dialogactions-spacebetween' : 'dialogactions-flexend'}
            showCloseButton={!user?.forcePasswordChange}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('currentPassword')}
                        name='currentPassword'
                        value={state.values.currentPassword}
                        required={true}
                        onChange={e => state.update(e.target.name, ValidationHelper.MaxLength(e.target.value.trim(), 20))}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('newPassword')}
                        name='newPassword'
                        value={state.values.newPassword}
                        required={true}
                        onChange={e => state.update(e.target.name, ValidationHelper.MaxLength(e.target.value.trim(), 20))}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('repeatNewPassword')}
                        name='repeatNewPassword'
                        value={state.values.repeatNewPassword}
                        required={true}
                        onChange={e => state.update(e.target.name, ValidationHelper.MaxLength(e.target.value.trim(), 20))}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default ChangePasswordDialog;